import { createStyles, makeStyles, Theme } from '@material-ui/core';

const ITEM_HEIGHT = 32;
const MIN_VISIBLE_ITEMS = 10.5;
const ITEM_PADDING_TOP = 8;

export const useCustomSelectStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      input: {
        cursor: 'pointer',
      },
      root: {
        color: 'black',
      },
      '@keyframes inputLoading': {
        '0%': {
          transform: 'scaleX(0)',
          transformOrigin: 'left center',
        },
        '50%': {
          transform: 'scaleX(1)',
          transformOrigin: 'left center',
        },
        '51%': {
          transform: 'scaleX(1)',
          transformOrigin: 'right center',
        },
        '100%': {
          transform: 'scaleX(0)',
          transformOrigin: 'right center',
        },
      },
      loading: {
        overflow: 'hidden',
        '&::after': {
          animation: '$inputLoading 2s ease infinite',
        },
      },
      adornment: {
        flexFlow: 'nowrap',
      },
      adornmentButton: {
        padding: 0,
        fontSize: 23,
        color: '#828a82',
        '&:first-of-type:not(:last-of-type)': {
          fontSize: 12,
          marginRight: 4,
        },
      },
      adornmentIcon: {
        transition: 'transform 200ms ease',
        transform: 'rotate(0)',
        color: '#828a82',
        width: '16px',
        height: '16px',
        marginLleft: '-16px',
        pointerEvents: 'none',
      },
      adornmentIconRotate: {
        transform: 'rotate(180deg)',
      },
      menu: {
        maxHeight: ITEM_HEIGHT * MIN_VISIBLE_ITEMS + ITEM_PADDING_TOP,
        borderRadius: 8,
        backgroundColor: '#fefefe',
        '@media (min-width:360px) and (max-width:400px)': {
          minHeight: '465px',
        },
        '@media (min-width:401px) and (max-width:402px)': {
          minHeight: '425px',
        },
        '@media (min-width:403px) and (max-width:449px)': {
          minHeight: '420px',
        },
        '@media (min-width:450px) and (max-width:599px)': {
          minHeight: '400px',
        },
        '@media (min-width:600px) and (max-width:620px)': {
          minHeight: '374px',
        },
        '@media (min-width:768px) and (max-width:865px)': {
          minHeight: '422px',
        },
        '@media (min-width:866px) and (max-width:1188px)': {
          minHeight: '400px',
        },
        '&::-webkit-scrollbar': {
          width: 12,
          height: 12,
        },
        '&::-webkit-scrollbar-button': {
          display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
          transition: 'all .3s ease',
          borderRadius: 10,
          backgroundColor: '#cdd3cd',
          border: '3px solid #f8f9f7',
        },
      },
      menuItem: {
        minHeight: ITEM_HEIGHT,
        whiteSpace: 'normal',
      },
      menuItemCheckbox: {
        minWidth: 'unset',
        marginRight: theme.spacing(1),
      },
      menuItemFilter: {
        position: 'sticky',
        top: 0,
        left: 0,
        backgroundColor: '#fefefe',
        zIndex: 2,
      },
      menuItemActions: {
        position: 'sticky',
        bottom: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'flex-start',
        backgroundColor: '#fefefe',
        zIndex: 2,
      },

      btnTextSelectedAll: {
        padding: '4px 0px',
        textAlign: 'start',
        fontSize: '80%',

        [theme.breakpoints.down('md')]: {
          padding: '4px 4px',
        },
      },
      btnTextRemoveAll: {
        padding: '4px 16px',
        textAlign: 'start',
        fontSize: '80%',
        [theme.breakpoints.down('md')]: {
          padding: '4px 4px',
        },
      },
    }),
  { name: 'CustomSelect' }
);
